"use client";

import { useEffect, useState } from "react";
import { useCustomSession } from "./useCustomSession";

interface UserServer {
	id: string;
	name: string;
	linked: number;
	createdAt: string;
	updatedAt: string;
}

export function useUserServers() {
	const { session } = useCustomSession();
	const [servers, setServers] = useState<UserServer[]>([]);
	const [isLoading, setIsLoading] = useState(true);
	const [hasServers, setHasServers] = useState(false);

	useEffect(() => {
		const fetchUserServers = async () => {
			if (!session?.user?.id) {
				setIsLoading(false);
				return;
			}

			try {
				const response = await fetch("/api/user/servers");

				if (response.ok) {
					const data = await response.json();
					setServers(data.servers || []);
					setHasServers(data.hasServers || false);
				} else {
					setServers([]);
					setHasServers(false);
				}
			} catch (error) {
				console.error("Error fetching user servers:", error);
				setServers([]);
				setHasServers(false);
			} finally {
				setIsLoading(false);
			}
		};

		fetchUserServers();
	}, [session]);

	return { servers, hasServers, isLoading };
}
